import { Grid, Typography } from '@mui/material';

const InvoiceRecommandationSection = ({ invoiceData }) => {
    return (
        <Grid item xl={12} md={12} sm={12} xs={12} boxShadow={0} pt={'24px'}>
            <div
                style={{
                    background: '#EBEBEB',
                    width: '100%',
                    height: '64px',
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    padding: '16px',
                    gap: '8px',
                    borderRadius: '4px 4px 0 0',
                }}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                        d="M11.2522 3.3804C10.9031 3.3804 10.6201 3.09739 10.6201 2.74832V2H9.01856V2.74832C9.01856 3.09739 8.73555 3.3804 8.38649 3.3804H7.31055V4.69642H12.3282V3.3804H11.2522ZM20.985 6.64541C20.5345 6.29861 19.886 6.38248 19.5392 6.83291L19.3053 7.13631L20.9353 8.39921L21.1725 8.09077C21.5193 7.64076 21.4351 6.99221 20.985 6.64541Z"
                        fill="#212121"
                    />
                    <path
                        d="M6.23763 12.473H13.4012C13.4632 12.473 13.5231 12.4823 13.5797 12.499L17.0252 8.02506V5.12614C17.0252 4.17782 16.2536 3.40633 15.3054 3.40633H13.5923V5.32848C13.5923 5.67755 13.3093 5.96056 12.9602 5.96056H6.67826C6.32919 5.96056 6.04619 5.67755 6.04619 5.32848V3.40625H4.33309C3.38477 3.40625 2.61328 4.17778 2.61328 5.12606V20.2801C2.61328 21.2285 3.38481 22 4.33309 22H15.3053C16.2536 22 17.0251 21.2284 17.0251 20.2801V15.5473L16.4393 16.3079C16.349 16.4255 16.2201 16.5074 16.0752 16.5392L13.5448 17.0997C13.5 17.1097 13.4542 17.1148 13.4083 17.1148C13.245 17.1148 13.0881 17.0517 12.9703 16.9386C12.8526 16.8255 12.7832 16.6712 12.7766 16.508L12.6721 13.9182C12.6699 13.8572 12.6765 13.7963 12.6917 13.7372H6.23763C5.88857 13.7372 5.60556 13.4542 5.60556 13.1051C5.60556 12.756 5.88853 12.473 6.23763 12.473ZM6.23763 15.8506H10.3872C10.7363 15.8506 11.0193 16.1336 11.0193 16.4826C11.0193 16.8317 10.7363 17.1147 10.3872 17.1147H6.23763C5.88857 17.1147 5.60556 16.8317 5.60556 16.4826C5.60556 16.1336 5.88857 15.8506 6.23763 15.8506ZM6.23763 9.09545H13.4012C13.7502 9.09545 14.0332 9.37846 14.0332 9.72753C14.0332 10.0766 13.7502 10.3596 13.4012 10.3596H6.23763C5.88857 10.3596 5.60556 10.0766 5.60556 9.72753C5.60556 9.37846 5.88853 9.09545 6.23763 9.09545Z"
                        fill="#212121"
                    />
                    <path d="M18.5337 8.13818L13.9443 14.0971L14.0088 15.7022L15.5777 15.3549L20.1632 9.40065L18.5337 8.13818Z" fill="#212121" />
                </svg>
                <Typography fontSize={20} lineHeight={'160%'} fontWeight={500} color={'#212121'} letterSpacing={'0.15px'}>
                    Notes & Recommendations
                </Typography>
            </div>
            <div style={{ padding: '16px', lineHeight: '24px', letterSpacing: '0.15px', fontSize: '16px', borderBottom: '1px solid rgba(0, 0, 0, 0.12' }}>
                {' '}
                {invoiceData?.recommendationNotes}
            </div>
        </Grid>
    );
};

export default InvoiceRecommandationSection;
